// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"165":"2ef8d3c9","376":"1bdea5b5"}[chunkId] + ".chunk.css";
};